import { Message } from "../../../types";

export const mockMessages: Message[] = [
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "1",
    text: "Hi!",
    is_bot: false,
    user_id: "alex_ivanov",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "2",
    text: "Hey! How’s it going?",
    is_bot: true,
    user_id: "bot",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "3",
    text: "Tell me, how can you be useful to me?",
    is_bot: false,
    user_id: "alex_ivanov",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "4",
    text: `I am here to support you in your journey of understanding Chronic Myeloid Leukemia (CML), and Scemblix (Asciminib), as well as integrating technology into healthcare.`,
    is_bot: true,
    user_id: "bot",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "5",
    text: "My Name is Alex",
    is_bot: false,
    user_id: "alex_ivanov",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
  {
    date: "2025-03-13T23:51:00.000Z",
    message_id: "6",
    text: `Hello Alex! I hope you're having a great day! Let's dive into some insights about Chronic Myeloid Leukemia (CML) and Scemblix (Asciminib) to help you enhance your understanding and support your professional development.`,
    is_bot: true,
    user_id: "bot",
    type: "text",
    message_type: "default",
    linked_with_previous: false,
    domain: "",
    focus: "",
  },
];

export const mockMessage: Message = {
  date: "2025-03-13T23:51:00.000Z",
  message_id: "2",
  text: "Hey! How’s it going?",
  is_bot: true,
  user_id: "bot",
  type: "text",
  message_type: "default",
  linked_with_previous: false,
  domain: "",
  focus: "",
};
